import React from 'react';
import { IconArrowRight } from '@tabler/icons-react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-navy h-16 flex items-center" data-id="element-162">
      <div className="max-w-6xl mx-auto w-full px-5 flex justify-between items-center" data-id="element-163">
        <div className="text-3xl tracking-tight font-body" data-id="element-164">
          <span className="text-white font-bold" data-id="element-165">Clean</span>
          <span className="font-bold text-[#69DFFF]" data-id="element-166">AI</span>
        </div>
        <button onClick={() => document.getElementById('waitlist-form')?.scrollIntoView({
        behavior: 'smooth'
      })} className="rounded-full uppercase tracking-wide hover:opacity-90 transition-opacity font-[500] px-6 py-2.5 text-[12px]" style={{
        backgroundColor: '#69ddff',
        color: '#000b29'
      }} data-id="element-167">
          Entra nella waitlist
          <IconArrowRight size={14} stroke={2} className="inline ml-1.5" data-id="element-168" />
        </button>
      </div>
    </nav>;
}